import { AxiosService } from './axiosService';

const paths = {
    priorities: '/issue-priorities',
    statuses: '/issue-statuses',
    types: '/issue-types',
};

export class IssueOptionsService extends AxiosService {
    async getOptions(kind) {
        const { data } = await this.axios.get(paths[kind]);
        return data;
    }

    async createOption(kind, name) {
        const { data } = await this.axios.post(paths[kind], { name });
        return data;
    }

    async updateOption(kind, id, name) {
        const { data } = await this.axios.put(paths[kind], { id, name });
        return data;
    }

    async deleteOption(kind, id) {
        const { data } = await this.axios.delete(`${paths[kind]}/${id}`);
        return data;
    }

    async getUsage(kind, id) {
        const { data } = await this.axios.get(`${paths[kind]}/${id}/usage`);
        return data;
    }
}

export const issueOptionsService = new IssueOptionsService();
